import React, {Component} from 'react';
//import logo from './logo.svg';
import './App.scss';
import Home from './components/home';
import getData from './getData';


class App extends Component {
  componentDidMount() {
  getData();
  }


  render() {
    return (
      <Home />
     );
  }
}


export default App;
